/**
 * Équivalent de la classe Pair de Kotlin
 */
export class Pair<T, U> {
    constructor(
        public first: T,
        public second: U,
    ) {}
}
